import React from "react";
import { getBranding } from "../../theme/branding";

const BrandMark = () => {
  const brand = getBranding();

  return (
    <>
      <span className="fs-4 d-sm-inline">
        <img src={ navigator.onLine ? brand.logo : process.env.REACT_APP_ESTABLISHMENT_LOGO  } alt={`${brand.displayName}`} height="40" className="rounded-circle" />
      </span>
      <span className="ms-2 fs-6 d-none d-sm-inline">{brand.shortName} {brand.countryCode && <><br />{brand.countryCode}</>} </span>
    </>
  );
};

export default BrandMark;
